import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled, { css } from 'styled-components';
import { brandColours, sectionPaddings, standardColours } from '../styles';
import CardSlider from './CardSlider';
import EventCard from './EventCard';

const StyledUpcomingEvents = styled.section`
  ${({ alt }) => {
    if (alt) {
      return css`
        ${sectionPaddings()};
        background-color: ${standardColours.lightestGrey};
      `;
    } else {
      return css`
        ${sectionPaddings()};
        color: ${standardColours.white};
        background-color: ${brandColours.primary};
      `;
    }
  }}
`;

const UpcomingEvents = ({ heading, items, alt, ...props }) => {
  const {
    allDatoCmsEvent: { nodes },
  } = useStaticQuery(graphql`
    query UpcomingEventsQuery {
      allDatoCmsEvent(sort: { startDate: ASC }) {
        nodes {
          ...EventCardFragment
        }
      }
    }
  `);

  const events = items ? items : nodes;

  const filteredEvents = events.filter(event => {
    const date = new Date(event.endDate);
    const today = new Date();
    if (date >= today) {
      return true;
    } else {
      return false;
    }
  });

  if (filteredEvents.length > 0) {
    return (
      <StyledUpcomingEvents alt={alt} {...props}>
        <CardSlider heading={heading} alt={!alt}>
          {filteredEvents.map((filteredEvent, id) => (
            <EventCard key={id} {...filteredEvent} />
          ))}
        </CardSlider>
      </StyledUpcomingEvents>
    );
  }
};

export default UpcomingEvents;
